import { useState } from "react";
import { useDispatch } from "react-redux";
import { setPersistentPlayerStatus } from "../../../../actions/PersistentPlayer/dispatcher";
import PersistentPlayerPlaceholder from "../../../PersistentPlayer/components/Placeholder/component";
import DefaultVideoUI from "../../../PersistentPlayer/components/Placeholder/components/DefaultVideoUI/component";
import IsMainContentContext from "../../../../context/IsMainContentContext";
import Playlist from "./components/Playlist/component";

const VideoPlaylist = ({
    layout = {},
    items = [],
    featureAttributionData = {},
}) => {
    const dispatch = useDispatch();
    const [ppData, setPPData] = useState({
        currentItem: {
            sourceId: "",
            feature: null,
        },
        autoPlay: false,
    });

    if (!items.length) return;

    const handlePlaylistSelection = (
        currentItem,
        autoPlay,
        featureAttribution,
        event = null
    ) => {
        event?.preventDefault();
        if (currentItem === undefined) return;

        const mediaItem = {
            sourceId: currentItem.sourceId ?? currentItem.videoId,
            source: currentItem.source,
            mediaId: currentItem.videoId,
            title: currentItem.title,
            image: currentItem.image,
            showData: { name: currentItem.show },
            type: currentItem.itemType,
            publishedAt: currentItem.videoAirDate?.toString() ?? "0",
            media: {
                duration: currentItem.videoDuration,
                hasCaptions: currentItem.videoHasCaptions,
                streamType: currentItem.videoStreamType,
            },
            feature: featureAttribution,
        };

        if (autoPlay) {
            dispatch(
                setPersistentPlayerStatus({
                    mediaItem: mediaItem,
                    sizeConfig: {
                        useMediaAspectRatio: false,
                        aspectRatio: "16:9",
                    },
                })
            );
        }
        setPPData({
            currentItem: mediaItem,
            autoPlay,
        });
    };

    const setPhoenixConfig = () => {
        return {
            routeUpdate: false,
            autoPlay: ppData.autoPlay,
            useMediaAspectRatio: false,
            aspectRatio: "16:9",
        };
    };

    return (
        <div className="video-playlist" data-testid="playlist">
            <PersistentPlayerPlaceholder
                config={setPhoenixConfig()}
                mediaItem={ppData.currentItem}
                featureAttribution={ppData.currentItem.feature}
                disableRecommendations={true}
                isMediaItemPlayable={false}
                render={DefaultVideoUI}
            />
            <IsMainContentContext.Provider value={false}>
                <Playlist
                    items={items}
                    itemSelectionCallback={handlePlaylistSelection}
                    selectedId={ppData.currentItem.sourceId}
                    playlistTitle={layout.playlistTitle}
                    featureAttributionData={featureAttributionData}
                />
            </IsMainContentContext.Provider>
        </div>
    );
};

export default VideoPlaylist;
